// Meses entre parcelas por periodicidade: o mesmo mapa de
// proptoken_backend/src/common/utils/get-months-by-frequency.ts
export const FREQUENCY_PAYMENTS: { [key: string]: string } = {
  one: '0',
  monthly: '1',
  quarterly: '3',
  quinterly: '5',
  semester: '6',
  year: '12'
}
